











import Vue from 'vue'
import activeForm from '@/components/Ui/ActiveForm/ActiveForm.vue'
import formConfig from '@/activeForms/CreateNewslettersStuff'
import UiSteps from '@/components/Ui/Steps/Steps.vue'
import {MAILING_STATUS_READY} from '@/constants'
import {DateTime} from 'luxon'
import firstStep from './steps/step_1.vue'
import secondStep from './steps/step_2.vue'
import thirdStep from './steps/step_3.vue'
import fourthStep from './steps/step_4.vue'
export default Vue.extend({
  components: {
    activeForm,
    UiSteps,
    firstStep,
    secondStep,
    thirdStep,
    fourthStep
  },
  data () {
    return {
      formConfig,
      formData: {},
      steps: [
        {label: this.$t('newsletters.steps.text')},
        {label: this.$t('newsletters.steps.recipients')},
        {label: this.$t('newsletters.steps.date')},
        {label: this.$t('newsletters.steps.settings')}
      ],
      activeStep: 1
    }
  },
  methods: {
    next (data: {}) {
      this.setData(data)
      if (++this.activeStep > 4) this.activeStep = 0;
    },
    prev () {
      if (--this.activeStep < 0) this.activeStep = 0;
    },
    setData (data: {}) {
      console.log('LOG: setData -> data', data)
      this.$set(this, 'formData', Object.assign(this.formData, data))
    },
    async onFormCancel () {
      // @ts-ignore
      if (this.formData.mailing_id) {
        // @ts-ignore
        await this.$store.dispatch('mailing/delete', this.formData.mailingId)
      }
      // @ts-ignore
      this.$refs.form.reset()
      // @ts-ignore
      this.$message({
        // @ts-ignore
        message: this.$t('newsletters.newsletter_canceled'),
        type: 'warning'
      });
    },
    async onFormSubmit (data: any) {
      try {
        // @ts-ignore
        let date = this.formData.date ? this.formData.date : DateTime.local().toMillis()
        console.log('LOG: onFormSubmit -> this.formData', this.formData)
        // @ts-ignore
        await this.$store.dispatch('mailing/update', {mailing_id: this.formData.mailingId, send_at: date, vote_type: this.formData.vote_type, text: this.formData.text})
        // @ts-ignore
        await this.$store.dispatch('mailing/setReady', this.formData.mailingId)
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t('newsletters.newsletter_create_success'),
          type: 'success'
        });
        // this.activeStep = 1
        // this.formData = {}
        // @ts-ignore
        this.$router.push({name: 'newsletterPageStuff', params: {id: this.formData.mailingId}})
      } catch (error) {
        console.error('LOG: onFormSubmit -> error', error)
        // @ts-ignore
        // @ts-ignore
        this.$message({
          // @ts-ignore
          message: this.$t('newsletters.send_error_notification'),
          type: 'error'
        });
      }
    }
  }
})
